import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoIosAdd } from 'react-icons/io';
import { FiChevronRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { SidebarHeader, ScrollableBox, NavBackButton, Feature } from '@mssgme/ui';

import { AdminHeaderSearch, ProductsListDraggable, ProductsListFooter } from '../UI';
import { useProductsMain } from '../hooks';
import { PageLayout } from '../../../../UI';

import styles from './ProductsMain.scss';

export default function ProductsMain() {
    const { t } = useTranslation('cards');
    const { collection, collections, products, setFilter, loadMore } = useProductsMain((col) => col.default);

    const activeCollectionsWithPublishedProductsCount = collections.items.filter(
        (col) => !col.default && col.published && col.publishedProductsCount > 0
    ).length;
    const activeCollectionsWithPublishedProductsCountTextTail = t(
        activeCollectionsWithPublishedProductsCount === 1
            ? 'PageProductsMain.activeSingleShe'
            : 'PageProductsMain.activeMany'
    );
    const ProductsCountTextTail = t(
        collections.allPublishedProductsCount === 1
            ? 'PageProductsMain.productsSingle'
            : collections.allPublishedProductsCount > 1 && collections.allPublishedProductsCount < 5
                ? 'PageProductsMain.products24'
                : 'PageProductsMain.productsMany'
    );

    return (
        <PageLayout className={styles.root}>
            <SidebarHeader
                heading={t('CardMain.products')}
                leftButton={<NavBackButton to="/p" />}
                rightButton={
                    <div className={styles.headerBtns}>
                        <Link
                            className={styles.headerLink}
                            to="/p/products/new"
                            title={t('pageProducts.tipAddProduct')}
                        >
                            <IoIosAdd size={34} color="#000" />
                        </Link>
                    </div>
                }
                style={{ boxShadow: 'none' }}
            />
            <ScrollableBox nopadding onBottomScroll={loadMore}>
                <Feature rule="products:?">
                    <AdminHeaderSearch onChange={setFilter} value={products.filter.name} />
                    {!products.filter.name && (
                        <>
                            <div>
                                <Link to="/p/products/collections" className={styles.navItem}>
                                    <span className={styles.navItemLabel}>{t('PageProductsMain.collections')}</span>
                                    <div className={styles.navItemMeta}>
                                        <span
                                            className={styles.navItemMetaText}
                                        >{`${activeCollectionsWithPublishedProductsCount} ${activeCollectionsWithPublishedProductsCountTextTail}`}</span>
                                        <FiChevronRight size={22} className={styles.navItemIcon} />
                                    </div>
                                </Link>
                            </div>
                            <div className={styles.storeFrontHeader}>
                                <span className={styles.storeFrontHeaderHeading}>
                                    {t('PageProductsMain.storeFront')}
                                </span>
                                <span className={styles.storeFrontHeaderCounter}>{`${
                                    collections.allPublishedProductsCount
                                } ${ProductsCountTextTail}`}</span>
                            </div>
                        </>
                    )}
                    <div>
                        {collection && (
                            <ProductsListDraggable
                                collectionId={collection.id}
                                products={products.items}
                                draggable={products.filter.name === ''}
                            />
                        )}
                    </div>

                    <ProductsListFooter products={products} loadMore={loadMore} />
                </Feature>
            </ScrollableBox>
        </PageLayout>
    );
}
